const SvgMenu = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M32 6.667H0V4h32zm0 10.666H0v-2.667h32zM32 28H0v-2.667h32z" />
  </svg>;
export default SvgMenu;